import { HttpErrorResponse } from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';

import { WebServiceResponse } from './responses/web-service-response';
import { Logger } from './logger';
import { GetObjectResponse } from './responses/get-object-response';

/**
 * This class executs an observable that gets data from the Crown Connect web service and returns a Promise.
 */
export class ExecuteObservable {

	/**
	 * Executes an observable that returns a WebServiceResponse object.
	 * 
	 * @param Observable An Observable<WebServiceResponse> that executes a web service method which doesn't return data.
	 * @param FunctionName The name of the parent method in the call stack - for error logging.
	 */
	public static ExecuteVoid(Observable: Observable<WebServiceResponse>, FunctionName: string): Promise<void> {
		let objSubscribe: Subscription;

		return new Promise((objResolve: Function, objReject: Function) => {
			objSubscribe = Observable.subscribe(
				(objResponse: WebServiceResponse) => {
					if (objResponse.OperationSucceeded)
						objResolve();
					else {
						Logger.LogError(FunctionName, objResponse.ErrorMessage);
						objReject(new Error(objResponse.ErrorMessage));
					}
					objSubscribe.unsubscribe();
				},
				(objError: HttpErrorResponse) => {
					Logger.LogError(FunctionName, objError.message);
					objReject(new Error(objError.message));
				});
		});
	}

	/**
	 *	Executes an observable that returns a GetObjectResponse object.
	 * 
	 * @param Observable An Observable<GetObjectResponse<T>> that executes a web service method which returns data.
	 * @param FunctionName The name of the parent method in the call stack - for error logging.
	 */
	public static ExecuteQuery<T>(Observable: Observable<GetObjectResponse<T>>, FunctionName: string): Promise<T> {
		let objSubscribe: Subscription;

		return new Promise((objResolve: Function, objReject: Function) => {
			objSubscribe = Observable.subscribe(
				(objResponse: GetObjectResponse<T>) => {
					if (objResponse.OperationSucceeded)
						objResolve(objResponse.Result);
					else {
						Logger.LogError(FunctionName, objResponse.ErrorMessage);
						objReject(new Error(objResponse.ErrorMessage));
					}
					objSubscribe.unsubscribe();
				},
				(objError: HttpErrorResponse) => {
					Logger.LogError(FunctionName, objError.message);
					objReject(new Error(objError.message));
				});
		});
	}

}